import React, { useState } from "react";
import { ChevronDown } from "lucide-react";

/** قسم إداري قابل للطي — تُحفظ حالته في المتصفح */
export const AdminSection = ({ id, title, desc, icon: Icon, defaultOpen = false, children }) => {
  const key = `rawaj_admin_sec_${id}`;
  const [open, setOpen] = useState(() => { const v = localStorage.getItem(key); return v === null ? defaultOpen : v === "1"; });
  const toggle = () => { setOpen((o) => { localStorage.setItem(key, o ? "0" : "1"); return !o; }); };
  return (
    <section className="rounded-2xl border border-border/70 bg-background/30 overflow-hidden" data-testid={`admin-section-${id}`}>
      <button type="button" onClick={toggle} aria-expanded={open} data-testid={`admin-section-toggle-${id}`}
        className="w-full flex items-center justify-between gap-3 px-4 py-3 text-start hover:bg-primary/5 transition-colors">
        <span className="flex items-center gap-3">
          {Icon && <span className="w-9 h-9 rounded-xl bg-primary/15 text-primary flex items-center justify-center shrink-0"><Icon className="w-4.5 h-4.5" /></span>}
          <span>
            <span className="block font-extrabold text-base">{title}</span>
            {desc && <span className="block text-xs text-muted-foreground">{desc}</span>}
          </span>
        </span>
        <ChevronDown className={`w-5 h-5 text-muted-foreground transition-transform ${open ? "rotate-180" : ""}`} />
      </button>
      {open && <div className="p-3 sm:p-4 space-y-6 border-t border-border/60" data-testid={`admin-section-body-${id}`}>{children}</div>}
    </section>
  );
};
